import { render, staticRenderFns } from "./FastSearchSwitcher.vue?vue&type=template&id=4842b673&scoped=true&"
import script from "./FastSearchSwitcher.vue?vue&type=script&lang=js&"
export * from "./FastSearchSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./FastSearchSwitcher.vue?vue&type=style&index=0&id=4842b673&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842b673",
  null
  
)

export default component.exports